export default __webpack_public_path__ + "static/media/iic 12.bbef8c67.jpg";